import React from "react";
import { connect } from "react-redux"
import { Button,Popper } from "@material-ui/core";
class PopperLevels extends React.Component{
    constructor(props){
        super(props)
        this.state={
        }
    }
    render(){ 
        return(
            <Popper
                open={this.props.open}
                anchorEl={this.props.anchorEl}
                placement={"right"}
                >
                <div ref={this.props.levelsWrapper} className="popover-levels">
                    <Button variant="contained" style={{backgroundColor:"red"}}
                     onClick={() => this.props.handleLevelClick(this.props.index,"fort",this.props.anchorEl.name)}>
                        Fort
                    </Button>
                    <Button variant="contained" style={{backgroundColor:"green"}}
                     onClick={() => this.props.handleLevelClick(this.props.index,"faible",this.props.anchorEl.name)}>
                        Faible
                    </Button>
                </div>
            </Popper>
        )
    }
}
const mapStateToProps = state => ({
	dossierValue: state.devis.dossierValue,
	dossier : state.dossier.items,
  });
  export default connect(mapStateToProps)(PopperLevels);